import DdSubHeader from '@/components/DdSubHeader'
import DdFileInput from '@/components/DdFileInput'
import DdSwitch from '@/components/DdSwitch'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdDataTable from '@/components/DdDataTable'

import flowMixin from '@/mixins/flowMixins'
import HttpClient from '@/rahmen/httpClient'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'

const fileSizeMax = 10485760

export default {
  name: 'TohoDejitakoTorikomi',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    tab: null,
    rec: {
      carDataList: [],
      costList: [],
      lubricationList: [],
      resultDataList: []
    },
    rec1: {},
    rec2: {},
    carDataSearchText: '',
    carDataRows: [],
    costSearchText: '',
    costRows: [],
    lubricationSearchText: '',
    lubricationRows: [],
    resultDataSearchText: '',
    resultDataRows: [],
    refs: {},
    invalidMessages: {},
    modeKengen: 2,
    carDataHeaders: [
      { text: '行数', value: 'csvRowNo' },
      { text: '処理結果', value: 'shoriResultDisp' },
      { text: '会社コード', value: 'digitakoKaishaCd' },
      { text: '処理営業所コード', value: 'shoriEigyoshoCd' },
      { text: '運転日報No', value: 'untenNippoNo' },
      { text: '車両コード', value: 'sharyoCd' },
      { text: '枝番', value: 'edaNo' },
      { text: '乗車日付', value: 'joshaYmdDisp', align: 'center' },
      { text: '降車日付', value: 'koshaYmdDisp', align: 'center' },
      { text: '乗車時刻', value: 'joshaMinDisp', align: 'center' },
      { text: '降車時刻', value: 'koshaMinDisp', align: 'center' },
      { text: '乗車積算走行距離', value: 'joshaSekisanSokoKyoriDisp', align: 'end' },
      { text: '降車積算走行距離', value: 'koshaSekisanSokoKyoriDisp', align: 'end' },
      { text: '乗車地点', value: 'joshaChiten' },
      { text: '降車地点', value: 'koshaChiten' },
      { text: 'エラー情報', value: 'errorMsg' }
    ],
    costHeaders: [
      { text: '行数', value: 'csvRowNo' },
      { text: '処理結果', value: 'shoriResultDisp' },
      { text: '会社コード', value: 'digitakoKaishaCd' },
      { text: '処理営業所コード', value: 'shoriEigyoshoCd' },
      { text: '運転日報No', value: 'untenNippoNo' },
      { text: '入力順', value: 'nyuryokuNo' },
      { text: '乗務員コード', value: 'jomuinCd' },
      { text: '車両コード', value: 'sharyoCd' },
      { text: '枝番', value: 'edaNo' },
      { text: '対象日', value: 'taishoYmdDisp', align: 'center' },
      { text: '費用区分', value: 'hiyoKbn' },
      { text: '金額', value: 'kingakuDisp', align: 'end' },
      { text: 'エラー情報', value: 'errorMsg' }
    ],
    lubricationHeaders: [
      { text: '行数', value: 'csvRowNo' },
      { text: '処理結果', value: 'shoriResultDisp' },
      { text: '会社コード', value: 'digitakoKaishaCd' },
      { text: '処理営業所コード', value: 'shoriEigyoshoCd' },
      { text: '運転日報No', value: 'untenNippoNo' },
      { text: '入力順', value: 'nyuryokuNo' },
      { text: '車両コード', value: 'sharyoCd' },
      { text: '枝番', value: 'edaNo' },
      { text: '処理日', value: 'shoriYmdDisp', align: 'center' },
      { text: '給油量', value: 'kyuyuryoDisp', align: 'end' },
      { text: 'エラー情報', value: 'errorMsg' }
    ],
    resultDataHeaders: [
      { text: '行数', value: 'csvRowNo' },
      { text: '処理結果', value: 'shoriResultDisp' },
      { text: '会社コード', value: 'digitakoKaishaCd' },
      { text: '処理営業所コード', value: 'shoriEigyoshoCd' },
      { text: '運転日報No', value: 'untenNippoNo' },
      { text: '乗務員コード', value: 'jomuinCd' },
      { text: '乗務員区分', value: 'jomuinKbn' },
      { text: '車両コード', value: 'sharyoCd' },
      { text: '枝番', value: 'edaNo' },
      { text: '走行距離', value: 'sokoKyoriDisp', align: 'end' },
      { text: '実車距離', value: 'jisshaKyoriDisp', align: 'end' },
      { text: '作業時間１', value: 'sagyoMin1Disp', align: 'center' },
      { text: '作業時間２', value: 'sagyoMin2Disp', align: 'center' },
      { text: '作業時間３', value: 'sagyoMin3Disp', align: 'center' },
      { text: '作業時間４', value: 'sagyoMin4Disp', align: 'center' },
      { text: '作業時間５', value: 'sagyoMin5Disp', align: 'center' },
      { text: '作業時間６', value: 'sagyoMin6Disp', align: 'center' },
      { text: '作業時間７', value: 'sagyoMin7Disp', align: 'center' },
      { text: '作業時間８', value: 'sagyoMin8Disp', align: 'center' },
      { text: '作業時間９', value: 'sagyoMin9Disp', align: 'center' },
      { text: '作業時間１０', value: 'sagyoMin10Disp', align: 'center' },
      { text: '作業時間１１', value: 'sagyoMin11Disp', align: 'center' },
      { text: 'エラー情報', value: 'errorMsg' }
    ],
    page: 1
  }),
  components: {
    DdSubHeader,
    DdFileInput,
    DdSwitch,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdDataTable
  },
  computed: {
    carDataRowCount () {
      return this.rec.carDataList.length
    },
    carDataFilteredRows () {
      return this.rec.carDataList
    },
    carDataFilteredRowCount () {
      const items = this.carDataHeaders.map(h => h.value)
      const text = this.carDataSearchText
      const length = this.carDataFilteredRows.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    },
    costRowCount () {
      return this.rec.costList.length
    },
    costFilteredRows () {
      return this.rec.costList
    },
    costFilteredRowCount () {
      const items = this.costHeaders.map(h => h.value)
      const text = this.costSearchText
      const length = this.costFilteredRows.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    },
    lubricationRowCount () {
      return this.rec.lubricationList.length
    },
    lubricationFilteredRows () {
      return this.rec.lubricationList
    },
    lubricationFilteredRowCount () {
      const items = this.lubricationHeaders.map(h => h.value)
      const text = this.lubricationSearchText
      const length = this.lubricationFilteredRows.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    },
    resultDataRowCount () {
      return this.rec.resultDataList.length
    },
    resultDataFilteredRows () {
      return this.rec.resultDataList
    },
    resultDataFilteredRowCount () {
      const items = this.resultDataHeaders.map(h => h.value)
      const text = this.resultDataSearchText
      const length = this.resultDataFilteredRows.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    },
    filteredCarDataList () {
      return this.rec.carDataList.map((elem) => {
        elem.shoriResultDisp = elem.shoriResultFlg ? 'OK' : 'NG'
        elem.joshaYmdDisp = filter.dateFormatter(elem.joshaYmd)
        elem.koshaYmdDisp = filter.dateFormatter(elem.koshaYmd)
        elem.joshaMinDisp = filter.minToTimeFormatter(elem.joshaMin)
        elem.koshaMinDisp = filter.minToTimeFormatter(elem.koshaMin)
        elem.joshaSekisanSokoKyoriDisp = filter.numericFormatter(elem.joshaSekisanSokoKyori) + 'km'
        elem.koshaSekisanSokoKyoriDisp = filter.numericFormatter(elem.koshaSekisanSokoKyori) + 'km'
        return elem
      })
    },
    filteredCostList () {
      return this.rec.costList.map((elem) => {
        elem.shoriResultDisp = elem.shoriResultFlg ? 'OK' : 'NG'
        elem.taishoYmdDisp = filter.dateFormatter(elem.taishoYmd)
        elem.kingakuDisp = filter.numericFormatter(elem.kingaku) + '円'
        return elem
      })
    },
    filteredLubricationList () {
      return this.rec.lubricationList.map((elem) => {
        elem.shoriResultDisp = elem.shoriResultFlg ? 'OK' : 'NG'
        elem.shoriYmdDisp = filter.dateFormatter(elem.shoriYmd)
        elem.kyuyuryoDisp = filter.numericFormatter(elem.kyuyuryo) + 'L'
        return elem
      })
    },
    filteredResultDataList () {
      return this.rec.resultDataList.map((elem) => {
        elem.shoriResultDisp = elem.shoriResultFlg ? 'OK' : 'NG'
        elem.sokoKyoriDisp = filter.numericFormatter(elem.sokoKyori) + 'km'
        elem.jisshaKyoriDisp = filter.numericFormatter(elem.jisshaKyori) + 'km'
        elem.sagyoMin1Disp = filter.minToTimeFormatter(elem.sagyoMin1)
        elem.sagyoMin2Disp = filter.minToTimeFormatter(elem.sagyoMin2)
        elem.sagyoMin3Disp = filter.minToTimeFormatter(elem.sagyoMin3)
        elem.sagyoMin4Disp = filter.minToTimeFormatter(elem.sagyoMin4)
        elem.sagyoMin5Disp = filter.minToTimeFormatter(elem.sagyoMin5)
        elem.sagyoMin6Disp = filter.minToTimeFormatter(elem.sagyoMin6)
        elem.sagyoMin7Disp = filter.minToTimeFormatter(elem.sagyoMin7)
        elem.sagyoMin8Disp = filter.minToTimeFormatter(elem.sagyoMin8)
        elem.sagyoMin9Disp = filter.minToTimeFormatter(elem.sagyoMin9)
        elem.sagyoMin10Disp = filter.minToTimeFormatter(elem.sagyoMin10)
        elem.sagyoMin11Disp = filter.minToTimeFormatter(elem.sagyoMin11)
        return elem
      })
    },
    isTorikomiButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        carDataSearchText: this.carDataSearchText,
        carDataRows: this.carDataRows,
        costSearchText: this.costSearchText,
        costRows: this.costRows,
        lubricationSearchText: this.lubricationSearchText,
        lubricationRows: this.lubricationRows,
        resultDataSearchText: this.resultDataSearchText,
        resultDataRows: this.resultDataRows,
        rec: this.rec,
        rec1: this.rec1,
        rec2: this.rec2
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const option = {
        nextCallback: next
      }
      this.preventTransition(option)
    },
    initialize () {
      const self = this
      const option = {
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              carDataList: [],
              costList: [],
              lubricationList: [],
              resultDataList: []
            }
            self.rec1 = {
              carData: '',
              cost: '',
              lubrication: '',
              resultData: ''
            }
            self.rec2 = {
              carDataFileNm: '',
              carDataFileData: '',
              costFileNm: '',
              costFileData: '',
              lubricationFileNm: '',
              lubricationFileData: '',
              resultDataFileNm: '',
              resultDataFileData: '',
              costUseFlg: true,
              lubricationUseFlg: true,
              impYmd: '',
              impHms: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            console.log('savedInputRestorePromise', c)
            console.log('savedInputRestorePromise', self.rec, self.rec1, self.rec2)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            self.rec1 = { ...self.rec1, ...c }
            self.rec2 = { ...self.rec2, ...c }
            console.log('savedInputRestorePromise', self.rec, self.rec1, self.rec2)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        settingButtonStatePromise: (kengen) => {
          console.log('TohoDejitakoTorikomi.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // CarDataファイル選択時changeイベント
    onChangeCarData: function (carDataFile) {
      if (carDataFile.size > fileSizeMax) {
        this.rec1.carData = ''
        this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0124', ['10MB']))
        return
      }
      if (carDataFile.name.indexOf('CarData') === -1) {
        this.rec1.carData = ''
        this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0125'))
        return
      }
      this.rec2.carDataFileNm = carDataFile.name
      const fr = new FileReader()
      fr.readAsDataURL(carDataFile)
      fr.addEventListener('loadend', () => {
        this.rec2.carDataFileData = fr.result
      })
      fr.addEventListener('error', () => {
        this.rec1.carData = ''
        this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0126'))
      })
    },
    // costファイル選択時changeイベント
    onChangeCost: function (costFile) {
      if (costFile.size > fileSizeMax) {
        this.rec1.cost = ''
        this.$refs.cost[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0124', ['10MB']))
        return
      }
      if (costFile.name.indexOf('Cost') === -1) {
        this.rec1.cost = ''
        this.$refs.cost[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0125'))
        return
      }
      this.rec2.costFileNm = costFile.name
      const fr = new FileReader()
      fr.readAsDataURL(costFile)
      fr.addEventListener('loadend', () => {
        this.rec2.costFileData = fr.result
      })
      fr.addEventListener('error', () => {
        this.rec1.cost = ''
        this.$refs.cost[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0126'))
      })
    },
    // lubricationファイル選択時changeイベント
    onChangeLubrication: function (lubricationFile) {
      if (lubricationFile.size > fileSizeMax) {
        this.rec1.lubrication = ''
        this.$refs.lubrication[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0124', ['10MB']))
        return
      }
      if (lubricationFile.name.indexOf('Lubrication') === -1) {
        this.rec1.lubrication = ''
        this.$refs.lubrication[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0125'))
        return
      }
      this.rec2.lubricationFileNm = lubricationFile.name
      const fr = new FileReader()
      fr.readAsDataURL(lubricationFile)
      fr.addEventListener('loadend', () => {
        this.rec2.lubricationFileData = fr.result
      })
      fr.addEventListener('error', () => {
        this.rec1.lubrication = ''
        this.$refs.lubrication[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0126'))
      })
    },
    // ResultDataファイル選択時changeイベント
    onChangeResultData: function (resultDataFile) {
      if (resultDataFile.size > fileSizeMax) {
        this.rec1.resultData = ''
        this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0124', ['10MB']))
        return
      }
      if (resultDataFile.name.indexOf('ResultsData') === -1) {
        this.rec1.resultData = ''
        this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0125'))
        return
      }
      this.rec2.resultDataFileNm = resultDataFile.name
      const fr = new FileReader()
      fr.readAsDataURL(resultDataFile)
      fr.addEventListener('loadend', () => {
        this.rec2.resultDataFileData = fr.result
      })
      fr.addEventListener('error', () => {
        this.rec1.resultData = ''
        this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0126'))
      })
    },
    onTorikomiButtonClick: function (e) {
      console.log('torikomi pushed')
      this.dejitakoTorikomi(this.rec2)
    },
    dejitakoTorikomi: function (param) {
      console.log(this.rec2.costFileData)
      this.Effects.loadStart()
      const isValid = this.dejitakoTorikomiValidate()
      if (!isValid) {
        this.Effects.loadComplete()
        return
      }
      param.impYmd = this.getDateYmdNow()
      param.impHms = this.getDateHmsNow()
      const httpClient = new HttpClient()
      console.log(param)
      const posturl = '/api/v1/THprmd0020/TohoDejitakoTorikomi'
      httpClient.post(posturl, param).then((data) => {
        if (data.summaryMessage === 'tohoDejitakoTorikomi') {
          this.setInvalidSummaryMessage('THPRM001')
          this.Effects.loadComplete()
          return
        }
        if (!data.isValid) {
          this.Effects.loadComplete()
          this.setInvalidSummaryMessage('COMC9999')
          return
        }
        if (data.payload) {
          this.rec.carDataList = data.payload.carDataList
          this.rec.resultDataList = data.payload.resultDataList
          if (data.payload.costList !== null) {
            this.rec.costList = data.payload.costList
          }
          if (data.payload.lubricationList !== null) {
            this.rec.lubricationList = data.payload.lubricationList
          }
          this.Effects.loadComplete()
        }
      }).catch((data) => {
        console.error(data)
        this.setInvalidSummaryMessage('COMC9999')
        this.Effects.loadComplete()
      })
    },
    dejitakoTorikomiValidate: function (e) {
      if (this.rec2.costUseFlg === true && this.rec2.lubricationUseFlg === true) {
        if (!this.rec2.carDataFileData || !this.rec2.costFileData || !this.rec2.lubricationFileData || !this.rec2.resultDataFileData) {
          this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.cost[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.lubrication[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.setInvalidSummaryMessage('COME0001')
          this.rec1.carData = ''
          this.rec1.cost = ''
          this.rec1.lubrication = ''
          this.rec1.resultData = ''
          return false
        }
      } else if (this.rec2.costUseFlg === true) {
        if (!this.rec2.carDataFileData || !this.rec2.costFileData || !this.rec2.resultDataFileData) {
          this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.cost[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.setInvalidSummaryMessage('COME0001')
          this.rec1.carData = ''
          this.rec1.cost = ''
          this.rec1.resultData = ''
          return false
        }
      } else if (this.rec2.lubricationUseFlg === true) {
        if (!this.rec2.carDataFileData || !this.rec2.lubricationFileData || !this.rec2.resultDataFileData) {
          this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.lubrication[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.setInvalidSummaryMessage('COME0001')
          this.rec1.carData = ''
          this.rec1.lubrication = ''
          this.rec1.resultData = ''
          return false
        }
      } else {
        if (!this.rec2.carDataFileData || !this.rec2.resultDataFileData) {
          this.$refs.carData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.$refs.resultData[this.Ctrls.SET_INVALID_METHOD](message.get('COME0004'))
          this.setInvalidSummaryMessage('COME0001')
          this.rec1.carData = ''
          this.rec1.resultData = ''
          return false
        }
      }
      return true
    },
    getDateYmdNow: function (e) {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const date = now.getDate()
      const dateYmdNow = year + '/' + month + '/' + date
      return dateYmdNow
    },
    getDateHmsNow: function (e) {
      const now = new Date()
      const hour = now.getHours()
      const min = now.getMinutes()
      const second = now.getSeconds()
      const dateHmsNow = hour + ':' + min + ':' + second
      return dateHmsNow
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const self = this
      const option = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('TohoDejitakoTorikomi.clearInputsPromise')
            self.rec = {
              carDataList: [],
              costList: [],
              lubricationList: [],
              resultDataList: []
            }
            self.rec1 = {
              carData: '',
              cost: '',
              lubrication: '',
              resultData: ''
            }
            self.rec2 = {
              carDataFileNm: '',
              carDataFileData: '',
              costFileNm: '',
              costFileData: '',
              lubricationFileNm: '',
              lubricationFileData: '',
              resultDataFileNm: '',
              resultDataFileData: '',
              costUseFlg: true,
              lubricationUseFlg: true,
              impYmd: '',
              impHms: ''
            }
            this.carDataSearchText = ''
            this.costSearchText = ''
            this.lubricationSearchText = ''
            this.resultDataSearchText = ''
            resolve()
          })
        }
      }
      this.clearInputs(option)
    },
    setShoriResultDispColor (shoriResultDisp) {
      if (shoriResultDisp === 'NG') return 'red--text'
      else if (shoriResultDisp === 'OK') return 'blue--text'
    }
  }
}
